import {Component, Input} from '@angular/core';

@Component({
  selector: 'pt-otp-qrcode',
  template: `
    <div *ngIf="currentLink">
      <qr-code value="{{currentLink}}"></qr-code>
    </div>
  `
})
export class OtpQrCodeComponent {
  @Input() currentLink: string;
}
